<!--  -->
<template>
  <div class="log-container">
    <div class="log-search">
      <a-table :data-source="tableData" :columns="columns" :pagination="false" :loading="loading">
        <template
          #filterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        >
          <div style="padding: 8px">
            <a-input
              :ref="c => (searchInput = c)"
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
            />
            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
            >
              <template #icon>
                <SearchOutlined />
              </template>
              Search
            </a-button>
            <a-button size="small" style="width: 90px" @click="handleReset(clearFilters)">Reset</a-button>
          </div>
        </template>
        <template
          #filterDropdownTime="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        >
          <div style="padding: 8px">
            <a-range-picker
              v-model:value="selectedKeys[0]"
              :placeholder="[`Search Start${column.dataIndex}`,`Search End${column.dataIndex}`]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              show-time
              @change="(date,dateString) => setSelectedKeys(date? [date] : [])"
            >
              <template #dateRender="{ current, today }">
                <div class="ant-calendar-date">{{ current.date() }}</div>
              </template>
            </a-range-picker>
            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="handleTimeSearch(selectedKeys, confirm, column.dataIndex)"
            >
              <template #icon>
                <SearchOutlined />
              </template>
              Search
            </a-button>
            <a-button size="small" style="width: 90px" @click="handleReset(clearFilters)">Reset</a-button>
          </div>
        </template>
        <template #time="{ text }">
          <span>{{text}}</span>
        </template>
        <template #filterIcon="filtered">
          <search-outlined :style="{ color: filtered ? '#108ee9' : undefined }" />
        </template>
        <template #multiple="{ text }">
          <span v-if="!text || text === 0">--</span>
          <span v-else>{{text}}</span>
        </template>
        <template #baseNum="{ text }">
          <span v-if="!text || text === 0">--</span>
          <span v-else>{{text}}</span>
        </template>
        <template #autoTargetNum="{ text }">
          <span v-if="!text || text === 0">--</span>
          <span v-else>{{text}}</span>
        </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :total="total"
        :show-total="total => `Total ${total} items`"
        :page-size="pageSize"
        v-model:current="current"
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, watch, watchEffect, computed } from "vue";
// 导入的其他文件 例如：import moduleName from 'modulePath';
import { SearchOutlined } from "@ant-design/icons-vue";
import { peopleCountLog } from "@/api/index.js";
import moment from "moment";
import { useStore } from "vuex";
export default {
  //import所引入的组件注册
  components: {
    SearchOutlined
  },
  setup() {
    const state = reactive({
      account: null,
      time: null,
      searchInput: null,
      searchTime: null,
      searchText: null,
      tableData: null,
      endTime: null,
      startTime: null,
      pageNumber: 1,
      total: 0,
      pageSize: 15,
      current: 1,
      loading: false,
      gameCode: ""
    });
    const store = useStore();
    const columns = [
      {
        title: "操作人",
        dataIndex: "operator",
        key: "operator",
        slots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: "operator"
        },
        onFilter: (value, record) =>
          record.operator
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              state.searchInput.focus();
            }, 0);
          }
        }
      },
      {
        title: "操作时间",
        dataIndex: "time",
        key: "time",
        slots: {
          filterDropdown: "filterDropdownTime",
          filterIcon: "filterIcon",
          customRender: "operatorTime"
        },
        onFilter: (value, record) =>
          record.time
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
      },
      {
        title: "增加倍数",
        dataIndex: "multiple",
        key: "multiple",
        slots: {
          customRender: "multiple"
        }
      },
      {
        title: "增加基数",
        dataIndex: "baseNum",
        key: "baseNum",
        slots: {
          customRender: "baseNum"
        }
      },
      {
        title: "增加时间段",
        dataIndex: "period",
        key: "period"
      },
      {
        title: "增加数量",
        dataIndex: "autoTargetNum",
        key: "autoTargetNum",
        slots: {
          customRender: "autoTargetNum"
        }
      }
    ];
    const initData = () => {
      state.loading = true;
      let params = {
        gameCode: state.gameCode,
        pageNumber: state.current
      };
      if (state.searchText) {
        params.operator = state.searchText;
      }
      if (state.startTime) {
        params.beginTime = state.startTime;
      }
      if (state.endTime) {
        params.endTime = state.endTime;
      }

      peopleCountLog(params).then(res => {
        setTimeout(() => {
          state.loading = false;
        }, 2000);
        if (res.status === 200) {
          state.tableData = res.data.peopleCountLogs;
          state.total = res.data.total;
          res.data.peopleCountLogs.forEach(item => {
            item.time = moment(item.operatorTime * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            item.period =
              item.autoStartTime != 0
                ? moment(item.autoStartTime * 1000).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ) +
                  " -- " +
                  moment(item.autoEndTime * 1000).format("YYYY-MM-DD HH:mm:ss")
                : "--";
          });
        }
      });
    };
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      state.searchText = selectedKeys[0];
      initData();
    };
    const handleTimeSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      state.startTime = moment(selectedKeys[0][0]).unix();
      state.endTime = moment(selectedKeys[0][1]).unix();
      initData();
    };
    const handleReset = clearFilters => {
      clearFilters();
      state.searchText = "";
      state.startTime = "";
      state.endTime = "";
      initData();
    };
    const pageChange = () => {
      initData();
    };
    let currentGameCodeRef = computed(
      () => store.state.settings.currentGamgeCode
    );
    watch([currentGameCodeRef], ([currentGameCode], [preCurrentGameCode]) => {
      if (currentGameCode) {
        state.gameCode = currentGameCode;
        initData();
      }
    });
    watchEffect(() => {
      if (store.state.settings.currentGamgeCode) {
        state.gameCode = store.state.settings.currentGamgeCode;
      }
      if (store.state.settings.loading && state.gameCode) {
        state.searchText = "";
        state.startTime = "";
        state.endTime = "";
        initData();
      }
    });
    return {
      ...toRefs(state),
      columns,
      handleSearch,
      handleTimeSearch,
      handleReset,
      pageChange
    };
  }
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import "./index.less";
.page {
  margin-top: 30px;
  #flex-box.column-end-end();
  margin-right: 30px;
}
</style>